// Read-only compatibility model. The legacy status remains authoritative until
// all existing clients have been upgraded and payment events are server owned.
export const deriveEntitlement = (deviceId, data = {}) => {
    const status = data.status || 'trial';
    const primaryId = data.linkedPrimaryId || deviceId;
    return {
        accountId: data.accountId || `legacy:${primaryId}`,
        deviceId,
        deviceStatus: data.secondaryRevokedAt ? 'revoked' : 'connected',
        accountStatus: status === 'rejected' ? 'rejected' : 'enabled',
        subscriptionStatus: status === 'active' ? 'active' :
            status === 'subscription_expired' ? 'expired' :
                status === 'pending' ? 'pending_manual_approval' : 'none',
        trialStatus: status === 'trial' ? 'in_progress' :
            data.trialStartDate ? 'completed' : 'not_started',
        legacyStatus: status,
        nextBillingDate: data.nextBillingDate || null
    };
};
